import React, { useEffect } from 'react'
import TopicCardDialog from './TopicCardDialog'
import NotificationTopicTable from './NotificationTopicTable'
import { useDispatch, useSelector } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { Routes } from 'app/services/routeService/routeService'
import effects from 'app/effects/effects'
import {
  setTopicDialogState,
  closeTopicDialog,
  topicNameError,
  setSubscribersTopics,
} from './store/actions/topic-action'
import * as R from 'ramda'

const styles = (theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
})

const Topics = (props) => {
  const { history, tableFetch } = props
  const { pageInfo, refetchData, startFetchData, endFetchData } = tableFetch
  const dispatch = useDispatch()
  const { dialogState, isOpenTopicDialog } = useSelector(
    (state) => state.topicReducer,
  )

  const setNameError = (error) => {
    if (Number(error.response.data.details.code) === 697) {
      dispatch(topicNameError())
      return
    }
  }
  const handleSubmitTopicCard = async (data) => {
    startFetchData()
    try {
      await effects.apis.createTopic(data)
      await refetchData()
      dispatch(closeTopicDialog())
    } catch (error) {
      setNameError(error)
    } finally {
      await endFetchData()
    }
  }

  const onClickTableRow = (data) => {
    dispatch(setTopicDialogState(data))
    history.push(Routes.viewTopics(data.id))
  }

  const fetchData = () => {
    return effects.apis.getSubscribersTopics().then((res) => {
      dispatch(setSubscribersTopics(R.prop('data', res)))
    })
  }

  const isNoTopicCard =
    pageInfo.isFirsttimeFetchingNoData &&
    tableFetch.filter.status === 'All' &&
    pageInfo.data.length === 0 &&
    !pageInfo.isLoading

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <NotificationTopicTable
        {...tableFetch}
        onClickRow={onClickTableRow}
        isNoTopicCard={isNoTopicCard}
        history={history}
      />
      <TopicCardDialog
        onSubmit={handleSubmitTopicCard}
        onClose={() => {
          dispatch(closeTopicDialog())
        }}
        dialogState={dialogState}
        isOpen={isOpenTopicDialog}
      />
    </>
  )
}

export default withStyles(styles, { withTheme: true })(Topics)
